export default "__VITE_ASSET__in7a0pwN__"